var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},_vm._l((_vm.options),function(o,index){return _c('div',{key:o,class:`tab ${o===_vm.value ? 'active': ''}`,on:{"click":function($event){return _vm.$emit('input', o)}}},[_vm._v(" "+_vm._s(_vm.labels[index] || o)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }